import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
}
export function Card({
  children,
  className = '',
  title
}: CardProps) {
  return <div className={`bg-white rounded-lg shadow-sm border border-gray-200 ${className}`} data-id="element-239">
      {title && <div className="px-6 py-4 border-b border-gray-200" data-id="element-240">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-241">{title}</h3>
        </div>}
      <div className="p-6" data-id="element-242">{children}</div>
    </div>;
}